import React from "react";
import { connect } from 'react-redux';
import { useHistory } from "react-router-dom";
import {
    Card,
    CardBody,
    CardHeader,
    Table,
    Button,
    Row,
    Col
} from "reactstrap";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import features from '../../variables/features';
import { paymentSetStep, paymentSetSubTime, paymentSetPaymentType  } from '../../redux/actions/payments.action';
function renderFeature ( t, data, plan ) {
    if (data.unlimited) {
        if (data.unlimited > plan)
            return (<span>1</span>);
        else
            return (<span>∞</span>);
    }
    return (<i className={`tim-icons ${ data.plan <= plan ? "icon-check-2 included" : "icon-simple-remove notincluded" }`}></i>);
}
const subscriptionDisplayName = ["Limited", "Basic", "Chad"];
const subscriptionName = ["light", "regular", "chad"];
const subscriptionPrice = [0.99, 4.99, 9.99];

const CheckOutCard = (props) => {
    const { t } = useTranslation(['plans']);
    let history = useHistory();
    const getDiscount = (time) => {
        if (props.paymentType === "subscription")
            switch (time) {
                case 12: return 25
                case 6: return 10
                case 3: return 5
                default: return 0;
            }
        else switch (time) {
            case 12: return 20
            case 6: return 8
            case 3: return 3
            default: return 0;
        }
    };
    return (
        <>
            <motion.div initial={{ opacity: 0.5, x: -100 }} animate={{ opacity: 1, x: 0, transition: { duration: 0.5 } }}>
                <Button className="backBtn" onClick={() => history.push("/plans")}>{t('checkout.backToOffers')}</Button>
            </motion.div>
            <motion.div initial={{ opacity: 0.5, x: 100 }} animate={{ opacity: 1, x: 0, transition: { duration: 0.5 } }}>
                <Row className="offersDisplay">
                        <Col xs="12" sm="6" lg="3" className="subscriptionTimeSelecter">
                            <Card className={`offer ${props.subscriptionTime === 12 && 'selected'}`} onClick={() => props.paymentSetSubTime(12)}>
                                <div className="subscriptionTimeDisplay">{t('checkout.yearPlan')}</div>
                                <div className="subscriptionPriceDisplay">€{(((12 * subscriptionPrice[props.vip-1]) - ((12 * subscriptionPrice[props.vip-1]) * getDiscount(12)/100))/12).toFixed(2)}</div>
                                <div className="subscriptionMonthDisplay">{t('checkout.perMonth')}</div>
                                <div className="subscriptionDiscountDisplay red-bg">{t('checkout.save', {percent: 25})}</div>
                                <div className="subscriptionPricesDisplay">
                                    <div className="subscriptionRealPriceDisplay">€{(subscriptionPrice[props.vip-1]*12).toFixed(2)}</div>
                                    <div className="subscriptionDiscountedPriceDisplay">€{((12 * subscriptionPrice[props.vip-1]) - ((12 * subscriptionPrice[props.vip-1]) * getDiscount(12)/100)).toFixed(2)} {t('checkout.for1Year')}</div>
                                </div>
                            </Card>
                        </Col>
                    <Col xs="12" sm="6" lg="3" className="subscriptionTimeSelecter">
                        <Card className={`offer ${props.subscriptionTime === 6 && 'selected'}`} onClick={() => props.paymentSetSubTime(6)}>
                            <div className="subscriptionTimeDisplay">{t('checkout.forXMonths', {time: 6})}</div>
                            <div className="subscriptionPriceDisplay">€{(((6 * subscriptionPrice[props.vip-1]) - ((6 * subscriptionPrice[props.vip-1]) * getDiscount(6)/100))/6).toFixed(2)}</div>
                            <div className="subscriptionMonthDisplay">{t('checkout.perMonth')}</div>
                            <div className="subscriptionDiscountDisplay orange-bg">{t('checkout.save', {percent: 10})}</div>
                            <div className="subscriptionPricesDisplay">
                                <div className="subscriptionRealPriceDisplay">€{(subscriptionPrice[props.vip-1]*6).toFixed(2)}</div>
                                <div className="subscriptionDiscountedPriceDisplay">€{((6 * subscriptionPrice[props.vip-1]) - ((6 * subscriptionPrice[props.vip-1]) * getDiscount(6)/100)).toFixed(2)} {t('checkout.forXMonths', {time: 6})}</div>
                            </div>
                        </Card>
                    </Col>
                    <Col xs="12" sm="6" lg="3" className="subscriptionTimeSelecter">
                        <Card className={`offer ${props.subscriptionTime === 3 && 'selected'}`} onClick={() => props.paymentSetSubTime(3)}>
                            <div className="subscriptionTimeDisplay">{t('checkout.forXMonths', {time: 3})}</div>
                            <div className="subscriptionPriceDisplay">€{(((3 * subscriptionPrice[props.vip-1]) - ((3 * subscriptionPrice[props.vip-1]) * getDiscount(3)/100))/3).toFixed(2)}</div>
                            <div className="subscriptionMonthDisplay">{t('checkout.perMonth')}</div>
                            <div className="subscriptionDiscountDisplay green-bg">{t('checkout.save', {percent: 5})}</div>
                            <div className="subscriptionPricesDisplay">
                                <div className="subscriptionRealPriceDisplay">€{(subscriptionPrice[props.vip-1]*3).toFixed(2)}</div>
                                <div className="subscriptionDiscountedPriceDisplay">€{((3 * subscriptionPrice[props.vip-1]) - ((3 * subscriptionPrice[props.vip-1]) * getDiscount(3)/100)).toFixed(2)} {t('checkout.forXMonths', {time: 3})}</div>
                            </div>
                        </Card>
                    </Col>
                    <Col xs="12" sm="6" lg="3" className="subscriptionTimeSelecter">
                        <Card className={`offer ${props.subscriptionTime === 1 && 'selected'}`} onClick={() => props.paymentSetSubTime(1)}>
                            <div className="subscriptionTimeDisplay">{t('checkout.monthPlan')}</div>
                            <div className="subscriptionPriceDisplay">€{subscriptionPrice[props.vip-1]}</div>
                            <div className="subscriptionMonthDisplay">{t('checkout.perMonth')}</div>
                            <div className="subscriptionDiscountDisplay grey-bg">{t('checkout.save', {percent: 0})}</div>
                            <div className="subscriptionPricesDisplay">
                                <div className="subscriptionDiscountedPriceDisplay">€{subscriptionPrice[props.vip-1]} {t('checkout.billedEveryMonth')}</div>
                            </div>
                        </Card>
                    </Col>
                </Row>
            </motion.div>
            <Row>
            <Col xs="12" lg="4">
                    <motion.div initial={{ opacity: 0.5, x: -100 }} animate={{ opacity: 1, x: 0, transition: { duration: 0.5 } }}>
                        <Row className="paymentType">
                            <Col xs="6">
                                <Card className={`paymentTypeCard ${props.paymentType === "subscription" && 'selected'}`} onClick={() => props.paymentSetPaymentType("subscription")}>
                                    <span className="paymentText">Subscription</span>
                                </Card>
                            </Col>
                            <Col xs="6">
                                <Card className={`paymentTypeCard ${props.paymentType === "onetime" && 'selected'}`} onClick={() => props.paymentSetPaymentType("onetime")}> 
                                    <span className="paymentText">One-time payment</span>
                                </Card>
                            </Col>
                        </Row>
                        <Card className="orderSummary">
                            <CardHeader className="title">{t('checkout.orderSummary')}</CardHeader>
                            <CardBody>
                                <div className="descriptions">
                                    <div className="description">
                                        <div className="left">{t('checkout.subscriptionPrice')}</div>
                                        <div className="right">€{subscriptionPrice[props.vip-1]}</div>
                                    </div>
                                    <div className="description">
                                        <div className="left">{t('checkout.subscriptionPeriod')}</div>
                                        <div className="right">{props.subscriptionTime} {t('checkout.month')}</div>
                                    </div>
                                    <div className="description">
                                        <div className="left">{t('checkout.discount')}</div>
                                        <div className="right">-{getDiscount(props.subscriptionTime) > 0 && `${getDiscount(props.subscriptionTime)}%`}</div>
                                    </div>
                                </div>
                                <div className="spacer"/>
                                <div className="descriptions">
                                    <div className="description">
                                        <div className="left total">{t('checkout.total')}</div>
                                        <div className="right total">€{((props.subscriptionTime * subscriptionPrice[props.vip-1]) - ((props.subscriptionTime * subscriptionPrice[props.vip-1]) * getDiscount(props.subscriptionTime)/100)).toFixed(2)}</div>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                        <Button className="checkoutBtn" onClick={() => props.paymentSetStep(2)}>{t('checkout.checkOut')}</Button>
                    </motion.div>
                </Col>
                <Col xs="12" lg="8">
                    <motion.div initial={{ opacity: 0.5, x: 100 }} animate={{ opacity: 1, x: 0, transition: { duration: 0.5 } }}>
                        <Card>
                            <CardHeader>Card</CardHeader>
                            <CardBody>
                                <Card className="tableCard">
                                    <Table>
                                        <thead className="tableHeader">
                                            <tr>
                                                <th>{t('checkout.product')}</th>
                                                <th>{t('checkout.month')}</th>
                                            </tr>
                                        </thead>
                                        <tbody className="products">
                                            <tr>
                                                <td className="desc">{subscriptionDisplayName[props.vip-1]} {t('checkout.subscription')}</td>
                                                {/*<td className="selectBtn">
                                                    <div className="selectMonths">
                                                        <button className={props.subscriptionTime === 1 && 'btnDisable'} onClick={() => props.paymentSetSubTime(props.subscriptionTime - 1)}>-</button>
                                                            {props.subscriptionTime}
                                                        <button className={props.subscriptionTime === 12 && 'btnDisable'} onClick={() => props.paymentSetSubTime(props.subscriptionTime + 1)}>+</button>
                                                    </div>
                                                </td>*/}
                                                <td className="selectBtn">
                                                    <div className="selectedMonths">
                                                        {props.subscriptionTime}
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </Card>
                            </CardBody>
                        </Card>
                    </motion.div>
                    <motion.div initial={{ opacity: 0.5, x: -100 }} animate={{ opacity: 1, x: 0, transition: { duration: 0.5 } }}>
                        <Card className="subscriptionSummary">
                            <CardHeader>{t('checkout.subscriptionSummary')}</CardHeader>
                            <CardBody>
                                <Table responsive>
                                    <thead className="text-primary">
                                        <tr key="titles">
                                            <th>{t('title.features')}</th>
                                            <th>{t(`title.${subscriptionName[props.vip-1]}`)}</th>
                                        </tr>
                                    </thead>
                                    <tbody className="tBodySettings">
                                        {
                                            features.map(e => {
                                                if (e.plan > props.vip) return false;
                                                return (<>
                                                        <tr key={e.key} className='prim'>
                                                            <td><div><span>{t(`${e.key}.title`)}</span><br></br><small>{t(`${e.key}.desc`)}</small></div></td>
                                                            <td>{renderFeature(t, e, props.vip)}</td>
                                                        </tr>
                                                        {e.sub && e.sub.map(s => {
                                                            if (s.plan > props.vip) return false;
                                                            return(<>
                                                                <tr key={s.key} className='sub'>
                                                                    <td><i>●</i>
                                                                    <div><span>{t(`${s.key}.title`)}</span><br></br><small>{t(`${s.key}.desc`)}</small></div></td>
                                                                    <td>{renderFeature(t, s, props.vip)}</td>
                                                                </tr>
                                                            </>)
                                                        })}
                                                    </>);
                                            })
                                        }
                                    </tbody>
                                </Table>
                            </CardBody>
                        </Card>
                    </motion.div>
                </Col>
            </Row>
        </>
    );
};

const mapStateToProps = (state) => {
    const { vip, subscriptionTime, paymentType } = state.payments;
    return { vip, subscriptionTime, paymentType };
};

const mapDispatchToProps = {
    paymentSetStep,
    paymentSetSubTime,
    paymentSetPaymentType
};

//export default Plans;
export default connect(mapStateToProps, mapDispatchToProps)(CheckOutCard);